import { useState, useCallback } from "react";

interface Props {
  value: string;
  label?: string;
  className?: string;
  displayMasked?: string; // tampilkan string lain, copy value asli
}

/**
 * CopyButton — button "SALIN" yang berubah jadi "TERSALIN" saat diklik.
 * Tidak ada animasi dekoratif — hanya swap teks + border color.
 */
export function CopyButton({ value, label = "SALIN", className = "", displayMasked }: Props) {
  const [copied, setCopied] = useState(false);

  const handle = useCallback(async () => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error("Copy failed:", e);
    }
  }, [value]);

  return (
    <button
      onClick={handle}
      className={`font-mono text-2xs tracking-widest uppercase border px-2 py-1 transition-none ${
        copied
          ? "border-terminal text-terminal bg-void"
          : "border-border-strong text-ink-muted hover:border-terminal hover:text-terminal"
      } ${className}`}
    >
      {copied ? "[ TERSALIN ]" : `[ ${label} ]`}
    </button>
  );
}

/**
 * MonoText — text monospace untuk keys, prices, data.
 */
export function MonoText({
  children,
  size = "sm",
  className = "",
  color = "terminal",
}: {
  children: React.ReactNode;
  size?: "xs" | "sm" | "base" | "lg";
  className?: string;
  color?:
    | "terminal"
    | "ink-primary"
    | "ink-muted"
    | "ink-dim"
    | "cyan"
    | "status-pending"
    | "status-failed"
    | "status-expired";
}) {
  const sizeClass = {
    xs: "text-2xs",
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
  }[size];
  const colorClass = {
    terminal: "text-terminal",
    cyan: "text-cyan",
    "ink-primary": "text-ink-primary",
    "ink-muted": "text-ink-muted",
    "ink-dim": "text-ink-dim",
    "status-pending": "text-status-pending",
    "status-failed": "text-status-failed",
    "status-expired": "text-status-expired",
  }[color];
  return (
    <span className={`font-mono ${sizeClass} ${colorClass} ${className}`}>
      {children}
    </span>
  );
}